import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditGeoAreas extends Component {

    state = {
        geoAreas: this.props.geoAreas.join(', ')
    }

    onSave = () => {
        this.props.onSave(this.state)
    }

    render() {
        const { geoAreas = '' } = this.state

        return (
          <Modal
            narrow
            extraClassName="EditGeoAreas"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="Geo areas">
            <Form>
                <div>
                    <input
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        placeholder="Geo areas"
                        value={geoAreas}
                        onChange={e => this.setState({ geoAreas: e.target.value })} />
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditGeoAreas



// WEBPACK FOOTER //
// ./src/components/LBUs/EditGeoAreas.js